/**
 *
 * @param list {Array} a list to remove duplicates from
 * @param compare {Function} compare function, takes 2 elements to compare, return true for duplicate
 * @returns {Array} a new list with no duplicates
 */
export const removeArrayDuplicates = (list, compare) =>
  list.filter((src, index) => index === list.findIndex((target) => compare(src, target)));
